import src from "IMAGE";
export default { src, width: 504, height: 1014, blurWidth: 4, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAPklEQVR42k2M2woAIAxC3aIL9f//m0YbE3zwcBDuvs1sAnAoHIsdbAug0avxQBr8WN9AAJ0OyRXMb5nAycFcN4EAzuhu+PgAAAAASUVORK5CYII="};
